import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { format } from "date-fns"

interface useTableColumnsReportesContratosGolondrinasProps {
    pagination?: { pageIndex: number; pageSize: number };
}

export const useTableColumnsReportesContratosGolondrinas = (props?: useTableColumnsReportesContratosGolondrinasProps) => {
    const { pagination } = props || {};

    const columnBase = useMemo<MRT_ColumnDef<any>[]>(() => [
        {
            accessorKey: 'numero',
            header: '#',
            size: 60,
            enableColumnFilter: false,
            Cell: ({ row }) => {
                // Calcular número absoluto basado en la página actual
                const baseNumber = pagination ? (pagination.pageIndex * pagination.pageSize) : 0;
                return baseNumber + row.index + 1;
            },
        },
        {
            accessorKey: 'identificacion',
            header: 'IDENTIFICACION',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'razon_social',
            header: 'RAZON SOCIAL',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'forma_de_pago',
            header: 'FORMA DE PAGO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'user_create_id',
            header: 'USER',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'canal_venta_create_id',
            header: 'DEPARTAMENTO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombre',
            header: 'PLAN',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'valorPlan',
            header: 'VALOR PLAN SOFTNET',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'puntaje_score_empresa',
            header: 'PUNTAJE SCORE',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'reportado_telcos',
            header: 'REPORTADO TELCO',
            size: 100,
            Cell: ({ cell }) => {
                const value = cell.getValue<boolean>();
                return value === true ? 'SI' : value === false ? 'NO' : '-';
            },
        },
        {
            accessorKey: 'fecha_creacion',
            header: 'FECHA CREACION',
            size: 100,
            Cell: ({ cell }) => {
                const fecha = cell.getValue() as string;
                if (fecha) {
                    try {
                        return format(new Date(`${fecha}T00:00:00`), 'dd/MM/yyyy');
                    } catch {
                        return fecha;
                    }
                }
                return '-';
            },
        },
        {
            accessorKey: 'fechaInstalacion',
            header: 'FECHA INSTALACION SOFTNET',
            size: 100,
            Cell: ({ cell }) => {
                const fecha = cell.getValue() as string;
                if (fecha) {
                    try {
                        return format(new Date(`${fecha}T00:00:00`), 'dd/MM/yyyy');
                    } catch {
                        return fecha;
                    }
                }
                return '-';
            },
        },
        {
            accessorKey: 'nombreVendedor',
            header: 'VENDEDOR SOFTNET',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'nombreCiudad',
            header: 'CIUDAD SOFTNET',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'estadoServicio',
            header: 'ESTADO SERVICIO SOFTNET',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'tieneDeuda',
            header: 'TIENE DEUDA',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'valorDeuda',
            header: 'VALOR DEUDA',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'fechaCambioEstado',
            header: 'FECHA CAMBIO DE ESTADO RETIRADO',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
    ], [pagination]);

    return {
        columnBase
    }
}
